import { render, staticRenderFns } from "./Tos.vue?vue&type=template&id=55f498a2"
import script from "./Tos.vue?vue&type=script&lang=js"
export * from "./Tos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports